// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCQZZtsdglHdQvWbOqrBHXXlDhCwb1Kxxc",
  authDomain: "golfadmin-bc10c.firebaseapp.com",
  projectId: "golfadmin-bc10c",
  storageBucket: "golfadmin-bc10c.firebasestorage.app",
  messagingSenderId: "355182480743",
  appId: "1:355182480743:web:7d211f0a0424bd5d9673c2",
  measurementId: "G-V8RW3YW4HZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;